import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { BuscadorSolicitudExService } from './solicitudes/buscador-solicitudEx.service';
import { BuscadorProductoExListComponent } from './productos/buscador-productoEx-list.component';
import { BuscadorProductoExService } from './productos/buscador-productoEx.service';
import { BuscadorSolicitudExListComponent } from './solicitudes/buscador-solicitudEx-list.component';
import { BuscadorAtestacionListComponent } from './atestaciones/buscador-atestacion-list.component';
import { BuscadorAtestacionService } from './atestaciones/buscador-atestacion.service';
import { BuscadorCpeListComponent } from './cpe/buscador-cpe-list.component';
import { BuscadorCpeService } from './cpe/buscador-cpe.service';
import { BuscadoresExRoutingModule } from './buscadoresEx-routing.module';
import { CertificadosFsService } from './certificadosfs/buscador-certificadosfs.service';
import { CertificadosFsWrapperEditComponent } from './certificadosfs/buscador-certificadosfs-wrapper-edit/buscador-certificadosfs-wrapper-edit.component';
import { BuscadorCertificadosFsWrapperComponent } from './certificadosfs/buscador-certificadosfs-wrapper/buscador-certificadosfs-wrapper.component';
import { CertificadosFsEditComponent } from './certificadosfs/buscador-certificadosfs-edit/buscador-certificadosfs-edit.component';
import { BuscadorCertificadosFsListComponent } from './certificadosfs/buscador-certificadosfs-list/buscador-certificadosfs-list.component';
import { BuscadorCertificadosFsFilterComponent } from './certificadosfs/buscador-certificadosfs-filter/buscador-certificadosfs-filter.component';

@NgModule({
    declarations: [
        BuscadorSolicitudExListComponent,
        BuscadorProductoExListComponent,
        BuscadorAtestacionListComponent,
        BuscadorCpeListComponent,
        BuscadorCertificadosFsWrapperComponent,
        BuscadorCertificadosFsListComponent,
        BuscadorCertificadosFsFilterComponent,
        CertificadosFsWrapperEditComponent,
        CertificadosFsEditComponent,
    ],
    exports: [],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, BuscadoresExRoutingModule],
    providers: [BuscadorSolicitudExService, BuscadorProductoExService, BuscadorAtestacionService, BuscadorCpeService, CertificadosFsService],
})
export class BuscadoresExModule {}
